import axios from 'axios'
import { env } from 'src/configs/env'

export const getReverseGeocode = async (at: string) => {
  return await axios.get<HereMapsResponse>(
    'https://revgeocode.search.hereapi.com/v1/revgeocode',
    {
      params: {
        at,
        apiKey: env.hereMapsApiKey,
        limit: 1,
      },
    }
  )
}

enum ResultType {
  ADDRESS_BLOCK = 'addressBlock',
  HOUSE_NUMBER = 'houseNumber',
  LOCALITY = 'locality',
  PLACE = 'place',
  STREET = 'street',
}

enum HouseNumberType {
  INTERPLOATED = 'interpolated',
  PA = 'PA',
}

type MapView = {
  east: number
  north: number
  south: number
  west: number
}

type Position = {
  lat: number
  lng: number
}

type Access = {
  lat: number
  lng: number
}

type Address = {
  city: string
  cityId: string
  countryName: string
  district: string
  houseNumber: string
  label: string
  postalCode: string
  state: string
  stateCode: string
  street: string
}

type Item = {
  access: Access[]
  address: Address
  distance: number
  houseNumberType: HouseNumberType
  id: string
  mapView: MapView
  position: Position
  resultType: ResultType
  title: string
}

type HereMapsResponse = {
  items: Item[]
}
